module.exports = require("./es-PA.d.ts");